<template>
  <UIAlert
    v-if="isBlockedForMigration"
    variant="warning"
    class="mx-4 mt-4"
    data-test-id="migration-blocked-banner"
  >
    <div class="flex flex-wrap items-center justify-between gap-3">
      <span>{{ $t('migrationBlock.banner.text') }}</span>
      <UIButton variant="warning" size="sm" @click="reload">
        {{ $t('generic.reload') }}
      </UIButton>
    </div>
  </UIAlert>
</template>

<script lang="ts" setup>
import { useUser } from '@manager/composables/use-user';
import { refreshAuthUser } from '@manager/utils/migration-block-utils';
import { useDocumentVisibility } from '@vueuse/core';
import UIAlert from 'shared/ui/registry/kinnovis/ui-alert/UIAlert.vue';
import UIButton from 'shared/ui/registry/kinnovis/ui-button/UIButton.vue';
import { watch } from 'vue';

const { isBlockedForMigration } = useUser();

// The flag is otherwise only refreshed on reload and on a migration 403.
// Not gated on `uses_kinnovis_billing` — migrating tenants still have it false.
watch(useDocumentVisibility(), (state) => {
  if (state === 'visible') {
    refreshAuthUser();
  }
});

function reload() {
  window.location.reload();
}
</script>
